var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('layout',{attrs:{"menu":_vm.menu,"config":_vm.config},scopedSlots:_vm._u([(_vm.$slots.header)?{key:"header",fn:function(){return [_vm._t("header")]},proxy:true}:null,(_vm.$slots.drawer)?{key:"drawer",fn:function(){return [_vm._t("drawer")]},proxy:true}:null],null,true)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }